import { useCallback, useContext } from "react";
import useApi from "./useApi";
import { ProductContext } from "contexts";
import { getProductsApi } from "apis";
import useAuth from "./useAuth";
import { PagesKeys, Path } from "enums";
import useRouter from "./useRouter";

const useProducts = (props) => {
  const { allProducts, setAllProducts } = useContext(ProductContext);
  const { stationCodes } = useAuth({ pageKey: PagesKeys.PRODUCTS });
  const { pathname } = useRouter();
  const getAllProducts = useApi({
    api: getProductsApi,
    key: props?.key,
    params: {
      stationCodes,
    },
  });

  const fetch = useCallback(
    async (props) => {
      if (Path.Products !== pathname && allProducts.length > 0) {
        return allProducts;
      }

      const res = await getAllProducts?.request(
        {
          page: 1,
          perPage: 1000,
        },
        () => 0,
        { useLoader: true },
      );

      const products = res.products;
      if (props?.filterResult && typeof props?.filterResult === "function") {
        setAllProducts(props.filterResult(products));
      } else {
        setAllProducts(products);
      }

      return products;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return {
    fetch,
    allProducts,
    setAllProducts,
    loading: getAllProducts.loading,
  };
};

export default useProducts;
